import {
  SET_ALL_COURSES_LIST,
  SET_SELECTED_COURSE,
  SET_LATEST_LIVE_SCHEDULED_TIMESTAMP,
  SET_SCHEDULING_DATA,
  SET_LINKED_LEARNING_PATHS_OF_COURSE,
} from '../actions/courseManagementActions';

const initialState = {
  allCoursesList: [],
  selectedCourse: null,
  latestLiveScheduledTimestamp: '',
  linkedLearningPathsOfCourse: [],
  schedulingData: {
    startDate: '',
    startTime: '',
  },
};

export const courseManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_COURSES_LIST: {
      return {...state, allCoursesList: action.payload};
    }
    case SET_SELECTED_COURSE: {
      return {...state, selectedCourse: action.payload};
    }
    case SET_LATEST_LIVE_SCHEDULED_TIMESTAMP: {
      return {...state, latestLiveScheduledTimestamp: action.payload};
    }
    case SET_SCHEDULING_DATA:
      return {
        ...state,
        schedulingData: {
          ...state.schedulingData,
          ...action.payload,
        },
      };
    case SET_LINKED_LEARNING_PATHS_OF_COURSE:
      return {...state, linkedLearningPathsOfCourse: action.payload};
    default: {
      return state;
    }
  }
};
